export default "__VITE_ASSET__f0e105e0__"